import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import Template from './Template';
import useOfferTags from '../../../hooks/useOfferTags';
import TagTypes from '../../../constants/TagTypes';

export default function Subjects(props) {
  const { offer } = props;

  const offerSubjects = useOfferTags(offer, TagTypes.Subject);

  if (offerSubjects.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (offerSubjects.data.length === 0) {
    return null;
  }

  return (
    <Template
      icon={BookOpenIcon}
      title="Subjects"
      subtitle="Offer is related to these subject areas."
      tags={offerSubjects}
    />
  );
};
